import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../Components/Admin/AdminLayout';
const API_BASE = process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api';
export default function InviteSettings() {
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [enabled, setEnabled] = useState(true);
  const [limit, setLimit] = useState(10);

  async function load() {
    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('HMI_AUTH_TOKEN');
      const res = await fetch(`${API_BASE}/admin/settings/invites`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const json = await res.json();

      if (json && json.success) {
        setEnabled(!!json.data.enforcementEnabled);
        setLimit(parseInt(json.data.defaultLimit || 10, 10));
      } else {
        throw new Error('Failed to load settings');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  async function save() {
    setError('');

    try {
      const token = localStorage.getItem('HMI_AUTH_TOKEN');
      const res = await fetch(`${API_BASE}/admin/settings/invites`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          enforcementEnabled: enabled,
          defaultLimit: limit
        })
      });
      const json = await res.json();
      if (!json || !json.success) throw new Error(json?.error?.message || 'Failed to save settings');
      await load();
      alert('Saved');
    } catch (e) {
      setError(e.message);
    }
  }

  const [clearingCache, setClearingCache] = useState(false);
  const [cacheStatus, setCacheStatus] = useState(null);

  async function handleClearCache() {
    setClearingCache(true);
    setCacheStatus(null);

    try {
      const token = localStorage.getItem('HMI_AUTH_TOKEN');
      const res = await fetch(`${API_BASE}/admin/clear-nginx-cache`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const json = await res.json();

      if (json && json.success) {
        setCacheStatus({
          success: true,
          message: `Success! Nginx cache is cleared (Verified empty: ${json.data.isCacheEmpty ? 'Yes' : 'No'}) and Nginx reloaded.`
        });
      } else {
        throw new Error(json?.error?.message || 'Failed to clear cache');
      }
    } catch (e) {
      setCacheStatus({
        success: false,
        message: `Error: ${e.message}`
      });
    } finally {
      setClearingCache(false);
    }
  }

  useEffect(() => {
    load();
  }, []);
  return <AdminLayout>
            <div className='container' style={{
      paddingTop: 24,
      paddingBottom: 48
    }}>
                <h3>{t("Invite Quota Settings")}</h3>
                {loading && <p>{t("Loading\u2026")}</p>}
                {error && <p style={{
        color: '#e74c3c'
      }}>{error}</p>}
                {!loading && <div style={{
        maxWidth: 480
      }}>
                        <div className='form-group'>
                            <label>
                                <input type='checkbox' checked={enabled} onChange={e => setEnabled(e.target.checked)} />{t("Enable Invite Quota Enforcement")}</label>
                        </div>
                        <div className='form-group'>
                            <label>{t("Default Pending Invite Limit")}</label>
                            <input type='number' className='form-control' value={limit} onChange={e => setLimit(parseInt(e.target.value || 0, 10))} />
                        </div>
                        <button className='btn btn-primary' onClick={save}>{t("Save")}</button>

                        <hr style={{
          margin: '32px 0 24px 0'
        }} />

                        <h3>{t("Nginx Cache Management")}</h3>
                        <p style={{
          fontSize: '0.9rem',
          color: '#666'
        }}>{t("Purge the Nginx Proxy Manager cache volumes and reload Nginx configuration to force serve live assets.")}</p>

                        <div style={{
          marginTop: 12
        }}>
                            <button className='btn btn-warning' disabled={clearingCache} onClick={handleClearCache}>
                                {clearingCache ? 'Clearing...' : 'Clear Nginx Cache & Reload'}
                            </button>
                            {cacheStatus && <p style={{
            marginTop: 8,
            color: cacheStatus.success ? '#2ecc71' : '#e74c3c',
            fontSize: '0.9rem',
            fontWeight: '500'
          }}>
                                    {cacheStatus.message}
                                </p>}
                        </div>
                    </div>}
            </div>
        </AdminLayout>;
}